import { Api } from "./api"

export class AuthApi extends Api {
  constructor() {
    super('auth', ['languagePreference', 'name','email', 'countryCode', 'password', 'passwordConfirmation', 'token', 'couponCode', 'termsOfService', 'companyAttributes', 'refreshToken', 'captchaToken', 'role', 'isQgrader', 'sawNavigationTutorial', 'isEvent', 'isProducer'])
  }
}
